import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Namespace the storage key by project ref so a stale session from a
// previous Supabase project (e.g. after re-linking) is never re-used.
// Extracts "abcd1234" from "https://abcd1234.supabase.co".
const projectRef = (() => {
  try { return new URL(url).hostname.split(".")[0]; }
  catch { return "default"; }
})();

// One-time cleanup: if the OLD generic key is still in localStorage from a
// previous version of the app, wipe it so it never gets accidentally rehydrated.
try {
  if (typeof window !== "undefined" && window.localStorage) {
    window.localStorage.removeItem("buildtrack_sb");
  }
} catch { /* ignore */ }

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: `buildtrack_sb_${projectRef}`,
  },
});
